module.exports = __webpack_public_path__ + "static/img/bg.659d1b91.jpg";